module.exports = __webpack_public_path__ + "img/top-3-4.a6357ed3.jpg";